export const leaseTermList = [
    'Weekly',
    'Month to Month',
    '12 Months',
    'Lease Purchase',
    'Negotiable',
    'Renewal Option',
    'None',
    'See Remarks'
];

export const petsAllowedList = [
    'Cats OK',
    'Dogs OK',
    'Small (< 20 lbs)',
    'Medium (< 35 lbs)',
    'Large (< 50lbs)',
    'No Weight Limit',
    'Number Limit',
    'Size Limit',
    'Breed Restrictions',
    'No Breed restrictions',
    'All',
    'No',
    'Call',
    'Negotiable'
];

export const additionPetFeeDescriptionList = ['1st Pet', 'Each', 'One Time', 'Per Additional Pet', 'Per Pet', 'See Remarks'];

export const applicationRequiredList = ['See Attached', 'See Online App', 'TXR App'];

export const oneTimeExpensesList = [
    'Admin Fee',
    'Amenity Fee',
    'Application Fee',
    'Assigned Covered Parking',
    'Pet Deposit',
    'Pet Fee',
    'None',
    'See Remarks'
];

export const recurringExpensesList = [
    'Assigned Covered Parking',
    'Assigned Garage Parking',
    'Assigned Surface Lot Parking',
    'Cable/Internet',
    'Gas Separate',
    'Heat/Air Conditioning',
    'Pet Rent',
    'Sewer',
    'Storage Fee',
    'Trash Removal',
    'Unassigned Covered Parking',
    'Unassigned Garage Parking',
    'Unassigned Surface Lot Parking',
    'Water',
    'None'
];
